export const Format = {
    Datetime: {
        DATETIME_ABBR_MONTH: "MMM D, YYYY h:mm A",
        DATE_ABBR_MONTH: "MMM D, YYYY",
    }
};
